export { CompilationSvg } from './CompilationSvg';
export { GeometricStacks } from './GeometricStacks';
export { LockedCircle } from './LockedCircle';
export { NoMediaCollected } from './NoMediaCollected';
export { NotFoundSvg } from './NotFoundSvg';
export { PluginCarouselIcon } from './PluginCarouselIcon';
export { PluginGalleryIcon } from './PluginGalleryIcon';
export { PluginListIcon } from './PluginListIcon';
export { PluginPlaylistIcon } from './PluginPlaylistIcon';
export { ReplyIcon } from './ReplyIcon';
export { Star } from './Star';
export { SubmissionsModalDeleteIcon } from './SubmissionsModalDeleteIcon';
export { UpdateThumbnailIcon } from './UpdateThumbnailIcon';
export { SelectCheckBoxIcon } from './SelectCheckBoxIcon';
export { InProgress } from './InProgress';



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/index.js